
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard, AppFormRow, AppInput, AppButton } from '@/components';
import { TableColumnType, TableConfig } from '@/components/table/types';
import { useArenaCycleRank } from '@/modules/arena/cycle/model/rank';
import { ROUTE_NAME_ACCOUNT } from '@/modules/account/router';
import { ROUTE_NAME_ARENA } from '@/modules/arena/router';

export default defineComponent({
    name: ROUTE_NAME_ARENA.CYCLE.RANK,
    components: { AppTable, AppCard, AppFormRow, AppInput, AppButton },
    setup() {
        const { query, v$, list, total, fetchList } = useArenaCycleRank();

        const table: TableConfig = {
            columns: [
                { type: TableColumnType.Index, label: '#' },
                { type: TableColumnType.Text, label: 'Account ID', key: 'accountId' },
                { type: TableColumnType.Text, label: 'Name', key: 'name' },
                { type: TableColumnType.Text, label: 'Position', key: 'position' },
                { type: TableColumnType.Text, label: 'Value', key: 'value' },
                { type: TableColumnType.Actions, label: 'Actions' }
            ],
            actions: [
                {
                    props: (row: any) => ({
                        icon: 'fa-users',
                        theme: 'info',
                        tooltip: 'Accounts',
                        to: { name: ROUTE_NAME_ACCOUNT.APP.DETAIL, params: { accountId: row.accountId } }
                    })
                }
            ]
        };

        onMounted(fetchList);

        return { query, list, total, v$, table, fetchList };
    }
});
